export class AppGlobal {


    public readonly Apps = {
        CAPA : 'CAPA',
        CLHUB: 'CLHUB'
    };
}
export const AutoRefresh ={
    reportRefresTime : 180000,
    dashBoardRefresTime : 300000,
    reports:[205],
    dashboard:[]
}